/**
 * @typedef {(ENTITIES | ENVIRONMENT | INTERACTIONS)} TypeLayer A layer.
 */

/**
 * The 'ENTITIES' layer.
 * @type {'entities'}
 * @constant
 */
const ENTITIES = 'entities';

/**
 * The 'ENVIRONMENT' layer.
 * @type {'environment'}
 * @constant
 */
const ENVIRONMENT = 'environment';

/**
 * The 'INTERACTIONS' layer.
 * @type {'interactions'}
 * @constant
 */
const INTERACTIONS = 'interactions';

export {

    ENTITIES,
    ENVIRONMENT,
    INTERACTIONS
};
